import * as React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Wrapper } from "../layout/Wrapper";
import { alpha, useTheme } from "@mui/material";

const userTestimonials = [
  {
    avatar: <Avatar>T</Avatar>,
    name: "Tom Walker",
    occupation: "Software Ehgineer",
    testimonial:
      "Collaborating with Snyprs has significantly boosted our project success through their innovative solutions and dedication.",
  },
  {
    avatar: <Avatar>L</Avatar>,
    name: "Lachlan Harper",
    occupation: "Software Engineer",
    testimonial:
      "Amazing work by fellow developers. Absolutely proud of the work, Wish them good luck for the future.",
  },

  {
    avatar: <Avatar>E</Avatar>,
    name: "Emma McKenzie",
    occupation: "Business Owner",
    testimonial:
      "They actively listened to our requirements and promptly addressed any issues that arose. They consistently went above and beyond to provide additional support and assistance.",
  },
  {
    avatar: <Avatar>D</Avatar>,
    name: "David Brown",
    occupation: "Business Owner",
    testimonial:
      "When I needed a product for my small business, I had tried many other options. However, after consulting with Snypers, they created exactly what I needed. It's evident that they genuinely meets user needs.",
  },
  {
    avatar: <Avatar>J</Avatar>,
    name: "Jack O'Connor",
    occupation: "Business Owner",
    testimonial:
      "They successfully delivered a top-notch software solution that perfectly aligns with our requirements.",
  },
  {
    avatar: <Avatar>A</Avatar>,
    name: "Artha Aryal",
    occupation: "Software Engineer",
    testimonial:
      "Their product's simplicity and user-friendliness have made a significant difference. I'm grateful to the developers for delivering a solution that not only meets but surpasses user expectations.",
  },
];

const Testimonials = ({ mode, toggleColorMode }) => {
  const theme = useTheme();
  return (
    <Wrapper mode={mode} toggleColorMode={toggleColorMode}>
      <Box
        sx={(theme) => ({
          width: "100%",
          background:
            theme.palette.mode === "light"
              ? // ? "linear-gradient(180deg, #CEE5FD, #FFF)"
                "#f6f4fa"
              : `linear-gradient(#02294F, ${alpha("#090E10", 0.0)})`,
          backgroundSize: "100% 20%",
          backgroundRepeat: "no-repeat",
        })}
      >
        <Container
          id="testimonials"
          sx={{
            pt: { xs: 14, sm: 20 },
            pb: { xs: 8, sm: 10 },
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: 3, sm: 6 },
          }}
        >
          <Box
            sx={{
              width: { sm: "100%", md: "60%" },
              textAlign: { sm: "left", md: "center" },
            }}
          >
            <Typography
              component="div"
              variant="body1"
              textAlign="center"
              sx={{
                color:
                  theme.palette.mode === "light"
                    ? theme.palette.secondary.main
                    : "#9043c6",
                fontWeight: "bold",
              }}
            >
              SEE WHAT OUR CLIENTS SAYS ABOUT US
            </Typography>
            <Typography
              component="h2"
              variant="h4"
              color="text.primary"
              textAlign="center"
              fontWeight="bold"
              sx={{ lineHeight: { xs: "2.5rem" }, mt: 4, mb: 4 }}
            >
              Testimonials
            </Typography>
            <Typography
              variant="body1"
              textAlign="center"
              color="text.secondary"
              sx={{ mb: { xs: 2, sm: 4 }, pt: { pt: 4 } }}
            >
              Real-life success stories from satisfied clients showcasing the
              impact and value of our services.
            </Typography>
          </Box>
          <Grid
            container
            spacing={2}
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            {userTestimonials.map((testimonial, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={index}
                sx={{ display: "flex" }}
              >
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    flexGrow: 1,
                    p: 1,
                  }}
                >
                  <CardContent>
                    <Typography variant="body2" color="text.secondary">
                      {testimonial.testimonial}
                    </Typography>
                  </CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      pr: 2,
                    }}
                  >
                    <CardHeader
                      avatar={testimonial.avatar}
                      title={testimonial.name}
                      subheader={testimonial.occupation}
                    />
                    {/* <img
                  src={logos[index]}
                  alt={`Logo ${index + 1}`}
                  style={logoStyle}
                /> */}
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Wrapper>
  );
};
export default Testimonials;
